// type TwitchIconProps = {
//     // width: number;
//     // height: number;
//     // color: string;
// };

// export default function TwitchIcon(props: TwitchIconProps) {
//     return (
//         <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64">
//             <path
//                 d="M5.7 0L1.4 10.985V55.88h15.284V64h8.597l8.12-8.12h12.418l16.716-16.716V0H5.7zm51.104 36.3L47.25 45.85H31.967l-8.12 8.12v-8.12H10.952V5.73h45.85V36.3zM47.25 16.716v16.716h-5.73V16.716h5.73zm-15.284 0v16.716h-5.73V16.716h5.73z"
//                 fill="#6441a4"
//                 fill-rule="evenodd"
//             />
//         </svg>
//     );
// }

import {SvgIcon} from '@mui/material';

// export default function TwitchIcon() {
//     return (
//         <Icon
//             style={{
//                 display: 'flex',
//                 height: 'inherit',
//                 width: 'inherit',
//             }}
//         >
//             <img
//                 style={{
//                     textAlign: 'center',
//                 }}
//                 src="https://storage.sbg.cloud.ovh.net/v1/AUTH_857d29cf94c54215b0da86e11c623b12/crowdfunding/icon/twitch.svg"
//             />
//         </Icon>
//     );
// }

export default function TwitchIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M4.265 3 3 6.236v13.223h4.502V21l2.531.85 2.392-2.391h3.658l4.923-4.924V3H4.265zm15.052 10.691-2.813 2.814h-4.502l-2.391 2.391v-2.391H5.813V4.688h13.504v9.003zm-2.812-5.767v4.923h-1.688V7.924h1.688zm-4.502 0v4.923h-1.688V7.924h1.688z" />
        </SvgIcon>
    );
}
